module.exports = __webpack_public_path__ + "i18n/ru_79bb665668c69ffd3ef3d233ac097749.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/m_ru.properties
// module id = flzm
// module chunks = 55